import {
  Component,
  ElementRef,
  ViewEncapsulation,
  Input,
  Output,
  OnChanges,
  OnInit,
  ViewChild,
  EventEmitter,
  SimpleChanges
} from '@angular/core';



export class InlineInputComponent implements OnInit {
   inputField: ElementRef;

   readOnly: boolean = false;
   set input(val) {
    this.inputValue = val;
    this.previousValue = val;
  }
   placeholder: string = 'Enter text here';
   onLineClickEdit: boolean = true;

   onSave = new EventEmitter();

  private inputValue: string = '';
  private saving: boolean = false;
  private editing: boolean = false;
  private previousValue: string = '';
  private errorMessage: string = '';

  ngOnInit() {
  }

  startEditing(event: Event, onLineClick: boolean) {
    this.errorMessage = '';
    if (!this.readOnly || !this.editing &&
      ((onLineClick && this.onLineClickEdit) || !onLineClick)) {
      this.editing = true;
      this.previousValue = this.inputField.nativeElement.value;
      this.inputField.nativeElement.focus();
    } else {
      this.inputField.nativeElement.blur();
    }
  }

  saveClick() {
    this.errorMessage = '';
    this.saving = true;
    this.onSave.emit({
      value: this.inputField.nativeElement.value,
      callBack: (v: string = '', e: string = '') => this.handleSave(v, e)
    });
  }

  closeClick() {
    this.errorMessage = '';
    this.inputValue = this.previousValue;
    this.inputField.nativeElement.value = this.previousValue;
    this.previousValue = '';
    this.editing = false;
  }

  handleSave(value: string, error: string) {
    this.errorMessage = error;
    this.saving = false;
    if (this.errorMessage) {}
    else {
      this.editing = false;
      this.inputValue = value;
    }
  }

  submitOnEnter(event) {
    event.preventDefault();
    this.saveClick();
    this.inputField.nativeElement.blur();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  encapsulation: ViewEncapsulation.None,
  selector: 'f8-inlineinput',
  templateUrl: './inlineinput.component.html',
  styleUrls: ['./inlineinput.component.less']
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'inputField': [{ type: ViewChild, args: ['input', ] },],
'readOnly': [{ type: Input, args: ['disabled', ] },],
'input': [{ type: Input, args: ['value', ] },],
'placeholder': [{ type: Input },],
'onLineClickEdit': [{ type: Input },],
'onSave': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
